export default __webpack_public_path__ + "static/media/icw-flowcharts.749fa675.jpg";